/**
 * Loads new content when a placeholder is at a certain position in the viewport.
 */

define('libs/photogallery',[],function() {

    'use strict';

    var SETTINGS = {
        imgLinkSelector: '.photo-element a.photo-link',
        overlaySelector: '.overlay',
        dialogSelector: '.photogallery-dialog',
        disabledClass: 'disabled'
    };

    var PhotoGallery = function(root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.root = root;

        this.images = this.root.find(this.settings.imgLinkSelector);
        this.root.on('click', this.settings.imgLinkSelector, this.handleImgClick.bind(this));
    };

    PhotoGallery.prototype.handleImgClick = function(event) {
        event.preventDefault();

        this.index = this.images.index(event.currentTarget);

        var img = $(event.currentTarget).find('img');
        if (img.length) {
            this.openImg(img);
        }
    };

    PhotoGallery.prototype.openImg = function(img) {
        this.dialog = $(this.settings.dialogSelector);
        this.currentImage = $('<img src="' + img.attr('src') + '"/>');
        this.dialog.find('.photogallery-dialog-wrapper').html(this.currentImage);

        this.btnNext = this.dialog.find('.btn-next');
        this.btnPrev = this.dialog.find('.btn-prev');

        this.btnNext.on('click', this.next.bind(this));
        this.btnPrev.on('click', this.prev.bind(this));
    };

    PhotoGallery.prototype.setPosition = function() {
        var instance = this.dialog.data('dialog_instance');
        if (instance) {
            instance.updatePosition();
        }
    };

    PhotoGallery.prototype.next = function() {
        var next = this.images.eq(this.index + 1);

        if (next.length) {
            this.btnPrev.removeClass(this.settings.disabledClass);
            var img = next.find('img');
            if (img.length) {
                this.index++;
                this.currentImage.attr('src', img.attr('src'));
                this.setPosition();
            }
        }

        next = this.images.eq(this.index + 1);
        if (!next.length) {
            this.btnNext.addClass(this.settings.disabledClass);
        }
    };

    PhotoGallery.prototype.prev = function() {
        var prev = this.images.eq(this.index - 1);
        if (prev.length) {
            this.btnNext.removeClass(this.settings.disabledClass);
            var img = prev.find('img');
            if (img.length) {
                this.index--;
                this.currentImage.attr('src', img.attr('src'));
                this.setPosition();
            }
        }

        prev = this.images.eq(this.index - 1);
        if (!prev.length) {
            this.btnPrev.addClass(this.settings.disabledClass);
        }
    };

    return PhotoGallery;
});

